module.exports = __webpack_public_path__ + "img/insetdown.658d3273.png";